import axios from "axios";
import { cacheGet } from "../util/cache";
import configs from "../config/app";

export const RefreshTokenCreateService = async (axiosInstance = axios) => {
  const parsedToken = cacheGet('apiToken', true, '{}');
  if (parsedToken?.jwtToken) {
    try {
      const { data } = await axios.post(`${configs.obeliskApi}api/v1/Authorize/RefreshToken`, parsedToken, { 
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${parsedToken.jwtToken}`
        }
      });
      
      if (data?.refreshToken) {
        // Update localStorage with new token
        localStorage.setItem('apiToken', JSON.stringify(data));
        
        // Update axios instance headers if provided
        if (axiosInstance?.defaults?.headers?.common) {
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${data?.jwtToken}`;
        }
        
        return data; // Return the new token data
      }
      
      throw new Error('No refresh token received');
    } catch (error) {
      console.error('Token refresh failed:', error);
      throw error; // Re-throw so calling code can handle
    }
  } else {
    throw new Error('No token available for refresh');
  }
};